module.exports = __webpack_public_path__ + "static/media/5.4fb7e09b.png";